<template>
  <div id="app">
    <MobileHeader v-if="!isAdminPage" />
    <TopBanner v-if="!isAdminPage" @open-register="openFloatingRegister" />
    <main class="main-content" :class="{ 'with-header': !isAdminPage }">
      <router-view />
    </main>
    <FooterSection v-if="!isAdminPage" />
    <MobileFloatingBar v-if="!isAdminPage" ref="floatingBar" />
  </div>
</template>

<script>
import TopBanner from '@/components/TopBanner.vue'
import MobileFloatingBar from '@/components/MobileFloatingBar.vue'
import MobileHeader from '@/components/MobileHeader.vue'
import FooterSection from '@/components/FooterSection.vue'

export default {
  name: 'App',
  components: { TopBanner, MobileFloatingBar, MobileHeader, FooterSection },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    }
  },
  methods: {
    openFloatingRegister() {
      if (this.$refs.floatingBar) {
        this.$refs.floatingBar.openRegister()
      }
    }
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css');
@import url('https://cdn.jsdelivr.net/gh/webfontworld/score/SCoreDream.css');

:root {
  /* Typography — 둥근 친근한 톤 */
  --font-sans: 'Pretendard Variable', 'Pretendard', -apple-system, sans-serif;
  --font-rounded: 'S-Core Dream', 'Pretendard Variable', 'Pretendard', sans-serif;
  --font-pretendard: var(--font-sans);

  /* Legacy aliases — 모두 둥근 산세리프로 통합 */
  --font-serif-kr: var(--font-rounded);
  --font-serif-en: var(--font-rounded);
  --font-display: var(--font-rounded);
  --font-mono-disp: var(--font-sans);

  /* 김포한강푸르지오리버프론트 — Brand Palette (푸르지오 그린 / 로고 #003030 기반) */
  --le-noir: #001A18;
  --le-ink: #0A2924;
  --le-charcoal: #143F38;
  --le-graphite: #315C52;
  --le-warm-grey: #6C8C84;
  --le-pearl: #E7F0ED;
  --le-bone: #D8E8E3;
  --le-cream: #F2F8F6;
  --le-white: #FFFFFF;

  /* Green accent (텍스트 / 라인 / 강조) — 로고 그린 #003030 기반 */
  --le-champagne: #15584C;
  --le-champagne-light: #2B7C6C;
  --le-champagne-dark: #003030;
  --le-gold-line: rgba(0, 48, 48, 0.32);
  --le-gold-line-soft: rgba(0, 48, 48, 0.16);

  /* Brand green (alias) */
  --le-orange: #15584C;
  --le-orange-light: #2B7C6C;
  --le-orange-dark: #003030;

  /* Legacy mapping for existing components */
  --primary: var(--le-noir);
  --primary-light: var(--le-ink);
  --primary-dark: #000000;
  --sub-color: var(--le-pearl);
  --text-color: #3A3A3A;
  --white: #ffffff;
  --font-family: var(--font-sans);
  --font-family2: var(--font-serif-en);
  --font-family4: var(--font-serif-kr);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--le-ink);
  background: #ffffff;
}

html, body {
  overflow-x: hidden;
  width: 100%;
  background: #ffffff;
}

img { display: block; max-width: 100%; }

.main-content.with-header {
  padding-top: 60px;
}

body.has-top-banner .main-content.with-header {
  padding-top: 120px;
}

#app {
  overflow-x: hidden;
  width: 100%;
}
</style>
